import { type IPikHistoryItem } from 'shared/components/PikHistory/external/models/PikHistoryItem';

import { type IChipsDataService } from '../IChipsDataService';

import { ChipsDataService } from './ChipsDataService';

/**
 * @description Сервис для работы с элементами истории ПИК
 * @param items - Массив элементов истории
 * @example
 * const pikHistoryItemsService = new PikHistoryItemsService(items);
 * const defaultItem = pikHistoryItemsService.defaultItem;
 * const activeItem = pikHistoryItemsService.getActiveItem('2021');
 */
export class PikHistoryItemsService
  extends ChipsDataService<IPikHistoryItem>
  implements IChipsDataService<IPikHistoryItem> {}
